module.exports = __webpack_public_path__ + "img/Sam-Slider-01.49cc75d1.jpg";